import { render, staticRenderFns } from "./tzfgRgSet.vue?vue&type=template&id=31b649f0&scoped=true&"
import script from "./tzfgRgSet.vue?vue&type=script&lang=js&"
export * from "./tzfgRgSet.vue?vue&type=script&lang=js&"
import style0 from "./tzfgRgSet.vue?vue&type=style&index=0&id=31b649f0&prod&scoped=true&lang=scss&"
import style1 from "./tzfgRgSet.vue?vue&type=style&index=1&id=31b649f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b649f0",
  null
  
)

export default component.exports